<ng-container *transloco="let t">
  @let placeholderSignal = resolvedPlaceholder();
  @let labelSignal = label() ?? '';
  @let itemsSignal = itemsFromInput() ?? [];
  <div #dropdownContainer>
    @if (!multiple() && (!isMobile || isSearch())) {
      <ng-select
        [readonly]="readonly()"
        [placeholder]="placeholderSignal"
        [items]="itemsSignal"
        [bindLabel]="labelSignal"
        bindValue="value"
        [virtualScroll]="true"
        [tabFocusOnClearButton]="false"
        (close)="onClose()"
        (open)="onOpen()"
        (blur)="onBlur()"
        [(ngModel)]="value"
        (ngModelChange)="onDropdownChange()"
        #dropdown
        [attr.title]="selectedItems"
        [ngClass]="isSearch() ? 'search' : ''"
        [disabled]="disabled() || isDisabled()"
        [labelForId]="id()"
      >
        <ng-template
          ng-option-tmp
          let-item="item"
          let-item$="item$"
          let-search="searchTerm"
        >
          @if (!item.subtitle) {
            <div class="d-flex justify-content-between w-100">
              <span [attr.title]="item.label">{{
                langKey() ? t(item.label) : item.label
              }}</span>
              @if (item$.selected || (!item.value && !selectedItems)) {
                <lib-icon
                  name="check"
                  size="small"
                  aria-hidden="true"
                ></lib-icon>
              }
            </div>
          }
          @if (item.subtitle) {
            <div class="d-flex justify-content-between w-100">
              <div class="d-flex flex-column span-container">
                <span [attr.title]="item.label"
                  >{{ langKey() ? t(item.label) : item.label }}
                  @if (item$.selected) {
                    <lib-icon
                      name="check"
                      size="small"
                      class="subtitle-icon"
                      aria-hidden="true"
                    ></lib-icon>
                  }
                </span>

                <span class="subtitle">{{ item.subtitle }}</span>
              </div>
            </div>
          }
        </ng-template>
        <ng-template ng-label-tmp let-item="item">
          @if (item.value) {
            <span class="ng-value-label">
              {{
                item.selectedLabel ?? (langKey() ? t(item.label) : item.label)
              }}
            </span>
          }
        </ng-template>
      </ng-select>
    }
    @if (multiple()) {
      <ng-select
        [readonly]="readonly()"
        [placeholder]="placeholderSignal"
        [items]="itemsSignal"
        [bindLabel]="labelSignal"
        bindValue="value"
        [virtualScroll]="true"
        [tabFocusOnClearButton]="false"
        [closeOnSelect]="false"
        (close)="onClose()"
        (keydown)="onKeyDown($event)"
        (blur)="onBlur()"
        [(ngModel)]="value"
        (ngModelChange)="onDropdownChange()"
        [multiple]="true"
        [maxSelectedItems]="max()"
        #dropdown
        [attr.title]="selectedItems"
        [disabled]="disabled() || isDisabled()"
        [labelForId]="id()"
      >
        <ng-template ng-multi-label-tmp let-items="items">
          {{ focus ? '' : selectedItems }}
        </ng-template>
        <ng-template
          ng-option-tmp
          let-item="item"
          let-item$="item$"
          let-search="searchTerm"
        >
          <div class="form-check">
            <input
              class="form-check-input"
              type="checkbox"
              [checked]="item$.selected"
              [disabled]="!item$.selected && max() === numberOfchoosenItems"
              [ngModel]="item$.selected"
            />
            <span class="form-check-label">{{
              langKey() ? t(item.label) : item.label
            }}</span>
          </div>
        </ng-template>
      </ng-select>
    }
    <span [attr.id]="'selecteditems_' + id()" class="visually-hidden">{{
      selectedItems
    }}</span>
    @if (isMobile && !multiple() && !isSearch()) {
      <span class="mobile-dropdown">
        <div [class.disabled]="disabled()">
          <span class="mobile-dropdown-label">{{
            selectedMobileLabel ?? placeholderSignal
          }}</span>
          <lib-icon name="chevron-down" size="small"></lib-icon>
        </div>
        @if (!disabled()) {
          <select
            [attr.id]="id()"
            (input)="onDropdownChange($event)"
            [attr.aria-label]="label() ?? placeholderSignal"
          >
            @if (!value) {
              <option selected disabled hidden>{{ placeholderSignal }}</option>
            }
            @for (item of itemsFromInput(); track $index) {
              <option
                [attr.value]="item.value"
                [attr.selected]="
                  item.value.toString() === value ? 'selected' : undefined
                "
                [attr.disabled]="item.disabled ? true : undefined"
              >
                {{ langKey() ? t(item.label) : item.label }}
              </option>
            }
          </select>
        }
      </span>
    }
  </div>
</ng-container>
